import { Modal, Box } from '@mui/joy';
import useAIModal from '../../../hooks/ai/useAIModal';
import { motion, AnimatePresence } from 'framer-motion';
import FarmartAIModalContent from './Content';

const MotionBox = motion(Box);

const FarmartAIModal = () => {
	const { onClose, open, modalProps } = useAIModal();
	return (
		<AnimatePresence>
			{open && (
				<Modal
					open
					onClose={onClose}
					sx={{
						backgroundColor: 'rgba(0, 0, 0, 0.2)',
						display: 'flex',
						alignItems: 'flex-end',
						justifyContent: 'center',
						zIndex: 1001,
					}}
					slotProps={{
						backdrop: { style: { background: 'transparent' } },
					}}
				>
					<MotionBox
						initial={{ y: '100%' }}
						animate={{ y: 0 }}
						exit={{ y: '100%' }}
						transition={{
							type: 'spring',
							stiffness: 300,
							damping: 30,
						}}
						sx={{
							width: '100vw',
							'@media (min-width: 1025px)': {
								width: '30vw',
							},
							backgroundColor: 'white',
							borderTopLeftRadius: 12,
							borderTopRightRadius: 12,
							maxHeight: '80vh',
							overflowY: 'auto',
							boxSizing: 'border-box',
							boxShadow: '0px -4px 20px rgba(0, 0, 0, 0.1)',
							outline: 'none',
						}}
					>
						<FarmartAIModalContent
							key={open.toString()}
							onClose={onClose}
							{...modalProps}
						/>
					</MotionBox>
				</Modal>
			)}
		</AnimatePresence>
	);
};
export default FarmartAIModal;
